export const contactsData = {
  email: "anujsachanid@gmail.com",
  phone: "+918858964726",
  address: "Kanpur Uttar Pradesh",

  sheetAPI: "",
};
